import { errors } from '@retailer-platform/dashboard/errors'

/**
 * This function is used to assert that the branch is never reached (and log if it is).
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#exhaustiveness-checking
 * @param param The param to check
 * @param throwError Optional, set to true to throw an error if this function is ever called in run-time
 */
export function assertExhaustive(
  param: never,
  { throwError = false }: { throwError?: boolean } = {}
): never {
  const error = new Error(`Exhaustive check failed: ${param}`)
  errors.captureMessage(`orders-operational-dashboard-exhaustive-check-error: ${param}`, {
    level: 'error',
    extra: {
      stack: error.stack,
    },
  })

  if (throwError) {
    throw error
  }

  return param
}
